<button mat-flat-button color="primary" (click)="switch()" class="action-button" *ngIf="lensConfigMode === LensConfigMode.SINGLE">
    <fa-icon *ngIf="side === 'LEFT'" [icon]="arrowLeft"></fa-icon>
    {{"newOrder.buttons.switch" | translate}}
    <fa-icon *ngIf="side === 'RIGHT'" [icon]="arrowRight"></fa-icon>
</button>
<button mat-flat-button color="primary" (click)="copy()" class="action-button" *ngIf="lensConfigMode === LensConfigMode.DUAL">
    <fa-icon *ngIf="side === 'LEFT'" [icon]="arrowLeft"></fa-icon>
    {{"newOrder.buttons.copy" | translate}}
    <fa-icon *ngIf="side === 'RIGHT'" [icon]="arrowRight"></fa-icon>
</button>